import { SidebarTopSection } from './SidebarTopSection';

export default SidebarTopSection;
